import { Address } from './queries';

export * from './queries';

export const addressesKey = {
  addressBySuggestion: (locale: string, query: string) => ['addressBySuggestion', locale, query],
  addressById: (id: string) => ['addressById', id],
  addressValidation: (address: Address) => ['addressValidation', address],
};
